import { authDomain } from '@auth';
import { useMutation } from '@tanstack/react-query';

export const useCheckPhone = () => {
  return useMutation((payload: authDomain.CheckPhoneDto) => {
    return authDomain.authService.checkPhone(payload);
  });
};
